(function () {
  'use strict';
  angular.module('imnApp').factory('TermosAceiteService', TermosAceiteService);

  TermosAceiteService.$inject = ['$http', 'RequestService'];

  function TermosAceiteService($http, RequestService) {
    return {
      informacoesSistema: informacoesSistema
    };

    function informacoesSistema() {
      return $http.get(systemConfigurationApi()).then(responseData);
    }

    function systemConfigurationApi(method) {
      return RequestService.apiUrl('system-configuration', method);
    }
  }
})();
